import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Login from "./components/Auth/Login";

import Dashboard from "./components/Dashboard";
import Layout from "./components/Layout";
import BankDetails from "./components/BankDetails";
import Payouts from "./components/Payouts";
import Transactions from "./components/Transactions";
import Landing from "./components/Landing";
import Referrals from "./components/Referrals";
import SocialLoginCallback from "./components/Auth/SocialLoginCallback";
import ResetPassword from "./components/Auth/ResetPassword";
import Drivers from "./components/Drivers";
import Promotion from "./components/Promotion";

export const CustomRoute = (props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/login/callback/social"
          element={<SocialLoginCallback />}
        />
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/drivers"
          element={
            <Layout>
              <Drivers />
            </Layout>
          }
        />
        <Route
          path="/statement"
          element={
            <Layout>
              <Transactions />
            </Layout>
          }
        />
        <Route
          path="/payouts"
          element={
            <Layout>
              <Payouts />
            </Layout>
          }
        />
        <Route
          path="/bank-details"
          element={
            <Layout>
              <BankDetails />
            </Layout>
          }
        />
        <Route
          path="/my-referrals"
          element={
            <Layout>
              <Referrals />
            </Layout>
          }
        />
        <Route
          path="/promotions"
          element={
            <Layout>
              <Promotion />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

function mapStateToProps(state) {}

function mapDispatchToProps(dispatch) {}

export default connect(mapStateToProps, mapDispatchToProps)(CustomRoute);
